// https://github.com/Luka967/websocket-close-codes#websocket-close-codes

/**
 * 1. inject jQuery
 * 2. Run script:

 (function($) {
	let constants = [];

	$('article.markdown-body.entry-content.p-5 table tbody tr').each(function() {
		let tr = $(this);
		let tds = tr.find('td');

		let code = $(tds[0]).text();
		let constant = $(tds[1]).text();
		let comment = $(tds[4]).text();

		constants.push(`const ${constant} = ${code}; // ${comment}`);
	});

	console.log(constants.join("\n"));

	console.log(table);
})(jQuery);

 * 3. Replace variables
 */
//const  = 0 - 999; // Unused
const _CLOSE_NORMAL = 1000; // Successful operation / regular socket shutdown
const _CLOSE_GOING_AWAY = 1001; // Client is leaving (browser tab closing)
const _CLOSE_PROTOCOL_ERROR = 1002; // Endpoint received a malformed frame
const _CLOSE_UNSUPPORTED = 1003; // Endpoint received an unsupported frame (e.g. binary-only endpoint received text frame)
const _RESERVED = 1004; // Reserved
const _CLOSED_NO_STATUS = 1005; // Expected close status, received none
const _CLOSE_ABNORMAL = 1006; // No close code frame has been receieved
const _UNSUPPORTED_PAYLOAD = 1007; // Endpoint received inconsistent message (e.g. malformed UTF-8)
const _POLICY_VIOLATION = 1008; // Generic code used for situations other than 1003 and 1009
const _CLOSE_TOO_LARGE = 1009; // Endpoint won't process large frame
const _MANDATORY_EXTENSION = 1010; // Client wanted an extension which server did not negotiate
const _SERVER_ERROR = 1011; // Internal server error while operating
const _SERVICE_RESTARTING = 1012; // Server/service is restarting
const _TRY_AGAIN_LATER = 1013; // Temporary server condition forced blocking client's request
const _BAD_GATEWAY = 1014; // Server acting as gateway received an invalid response
const _TLS_HANDSHAKE_FAILED = 1015; // Transport Layer Security handshake failure
//const  = 1016 - 1999; // Reserved for later
//const  = 2000 - 2999; // Reserved for websocket extensions
//const  = 3000 - 3999; // Registered first come first serve at IANA
//const  = 4000 - 4999; // Available for applications

export const CLOSE_NORMAL = _CLOSE_NORMAL; // Successful operation / regular socket shutdown
export const CLOSE_GOING_AWAY = _CLOSE_GOING_AWAY; // Client is leaving (browser tab closing)
export const CLOSE_PROTOCOL_ERROR = _CLOSE_PROTOCOL_ERROR; // Endpoint received a malformed frame
export const CLOSE_UNSUPPORTED = _CLOSE_UNSUPPORTED; // Endpoint received an unsupported frame (e.g. binary-only endpoint received text frame)
export const RESERVED = _RESERVED; // Reserved
export const CLOSED_NO_STATUS = _CLOSED_NO_STATUS; // Expected close status, received none
export const CLOSE_ABNORMAL = _CLOSE_ABNORMAL; // No close code frame has been receieved
export const UNSUPPORTED_PAYLOAD = _UNSUPPORTED_PAYLOAD; // Endpoint received inconsistent message (e.g. malformed UTF-8)
export const POLICY_VIOLATION = _POLICY_VIOLATION; // Generic code used for situations other than 1003 and 1009
export const CLOSE_TOO_LARGE = _CLOSE_TOO_LARGE; // Endpoint won't process large frame
export const MANDATORY_EXTENSION = _MANDATORY_EXTENSION; // Client wanted an extension which server did not negotiate
export const SERVER_ERROR = _SERVER_ERROR; // Internal server error while operating
export const SERVICE_RESTARTING = _SERVICE_RESTARTING; // Server/service is restarting
export const TRY_AGAIN_LATER = _TRY_AGAIN_LATER; // Temporary server condition forced blocking client's request
export const BAD_GATEWAY = _BAD_GATEWAY; // Server acting as gateway received an invalid response
export const TLS_HANDSHAKE_FAILED = _TLS_HANDSHAKE_FAILED; // Transport Layer Security handshake failure

export function webSocketCodeToString(code) {
    if (code >= 0 && code <= 999) {
        return 'Unused';
    } else if (code >= 1016 && code <= 1999) {
        return 'Reserved for later';
    } else if (code >= 2000 && code <= 2999) {
        return 'Reserved for websocket extensions';
    } else if (code >= 3000 && code <= 3999) {
        return 'Registered first come first serve at IANA';
    } else if (code >= 4000 && code <= 4999) {
        return 'Available for applications';
    } else if (code === _CLOSE_NORMAL) {
        return 'CLOSE_NORMAL';
    } else if (code === _CLOSE_GOING_AWAY) {
        return 'CLOSE_GOING_AWAY';
    } else if (code === _CLOSE_PROTOCOL_ERROR) {
        return 'CLOSE_PROTOCOL_ERROR';
    } else if (code === _CLOSE_UNSUPPORTED) {
        return 'CLOSE_UNSUPPORTED';
    } else if (code === _RESERVED) {
        return 'RESERVED';
    } else if (code === _CLOSED_NO_STATUS) {
        return 'CLOSED_NO_STATUS';
    } else if (code === _CLOSE_ABNORMAL) {
        return 'CLOSE_ABNORMAL';
    } else if (code === _UNSUPPORTED_PAYLOAD) {
        return 'UNSUPPORTED_PAYLOAD';
    } else if (code === _POLICY_VIOLATION) {
        return 'POLICY_VIOLATION';
    } else if (code === _CLOSE_TOO_LARGE) {
        return 'CLOSE_TOO_LARGE';
    } else if (code === _MANDATORY_EXTENSION) {
        return 'MANDATORY_EXTENSION';
    } else if (code === _SERVER_ERROR) {
        return 'SERVER_ERROR';
    } else if (code === _SERVICE_RESTARTING) {
        return 'SERVICE_RESTARTING';
    } else if (code === _TRY_AGAIN_LATER) {
        return 'TRY_AGAIN_LATER';
    } else if (code === _BAD_GATEWAY) {
        return 'BAD_GATEWAY';
    } else if (code === _TLS_HANDSHAKE_FAILED) {
        return 'TLS_HANDSHAKE_FAILED';
    } else {
        return null;
    }
}